import './Hero.css';
import landingBg from '../../assets/images/landing_bg.jpg';

function Hero() {
  return (
    <section id="hero" className="hero">
      <img src={landingBg} alt="Rocaille Restaurant & Bar Düsseldorf" className="hero__image" />
    </section>
  );
}

export default Hero;
